import './studymaterialcard.css';
import '../DOC/docCard.css';
import StudymDoc from './studymDoc';
import React, { useEffect, useState } from 'react';

const CardView = (props) => {
  const [documentList, setDocumentList] = useState([]);

  useEffect(() => {
    if (Array.isArray(props.globalDocuments)) {
      // ✅ Use already processed globalDocuments directly
      const updatedDocs = props.globalDocuments.map((doc) => ({
        ...doc,
        isMarked: !!doc.isMarked,
        // Lock state is already handled in generateGlobalDocs
        isLocked: doc.isLocked,
      }));
      console.log("📥 Initial docList (CardView):", updatedDocs);
      setDocumentList(updatedDocs);
    }
  }, [props.globalDocuments]);

  const handleMarkAsComplete = (index) => {
    console.log(`✅ Marking index ${index} as complete`);
    setDocumentList((prev) => {
      const updated = [...prev];
      updated[index].isMarked = true;
      if (index + 1 < updated.length) {
        updated[index + 1].isLocked = false;
      }
      return updated;
    });

    // Call parent handler too
    if (props.handleMarkAsComplete) {
      props.handleMarkAsComplete(index);
    }
  };
  const handleFileOpen = (el) => {
    console.log("📌 handleFileOpen() triggered for: ", el);
  
    const fileName = el?.file_name ?? '';
    const ext = fileName.split('.').pop().toLowerCase();
  
    console.log("🧾 File Name:", fileName, " | 🔎 Extension:", ext);
  
    const imageTypes = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
    const audioTypes = ['mp3', 'aac', 'wav', 'ogg'];
    const documentTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'];
  
    if (imageTypes.includes(ext)) { console.log("📷 Opening IMAGE ▶"); props.image(el); }
    else if (audioTypes.includes(ext)) { console.log("🔊 Opening AUDIO ▶"); props.listen(el); }
    else if (documentTypes.includes(ext)) { console.log("📄 Opening DOCUMENT ▶"); props.view(el); }
    else if (el.videoID && el.is_vdocipher) { console.log("🎥 VDOCipher ▶"); props.vdocipherApicalling(el); }
    else if (el.videoID && el.is_vimeo) { console.log("🎬 Vimeo ▶"); props.vimeo(el); }
    else if (el.youtubeVideoID) { console.log("▶ YouTube ▶"); props.youtubeVideo(el); }
    else { console.log("⚠ UNKNOWN → default view"); props.view(el); }
  };
  
  
  return (
    <div>
      {documentList.map((data, index) => {
        const show =
          (props.topicId === 0 || props.topicId === data.topic_id) &&
          (props.search === '' || data.title?.toUpperCase().includes(props.search.toUpperCase()));

        return (
          show && (
            <StudymDoc
              key={index}
              el={data}
              index={index}
              institute_id={props.institute_id}
              student_id={props.student_id}
              user_id={props.user_id}
              student_auth={props.student_auth}
              heading_name={data.title}
              date={data.student_file_share_date}
              type={data.type}
              file_name={data?.file_name ?? ''}
              topic={data.topic_name}
              category_name={data.category_name}
              download={props.download}
              view={props.view}
              downloadvimeo={props.downloadvimeo}
              UpdatVimeoWatchCall={props.UpdatVimeoWatchCall}
              vdocipherApicalling={props.vdocipherApicalling}
              youtubeVideo={props.youtubeVideo}
              vimeo={props.vimeo}
              image={props.image}
              listen={props.listen}
              is_readonly={data.is_readonly}
              handleClick={handleFileOpen}   // add this line

              vimeo_video_downlodable={props.subjectData?.vimeo_video_downlodable}
              video_url={data.video_url}
              posterUrl={data.posterUrl}
              posterList={data.posterList}
              isLocked={data.isLocked}
              isMarked={data.isMarked}
              onMarkComplete={() => handleMarkAsComplete(index)}
            />
          )
        );
      })}
    </div>
  );
};

export default CardView;